import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { colorStringForShort, CustomisationKey } from "@scenes/pdp/types";
import { getCommentData, hasZeroDecimals } from "@scenes/pdp/utils/utils";
import { GlobalEnum } from "@utils/constants";
import { isMeleeItem } from "@utils/product/productValidators";
import currency from "currency.js";
import moment from "moment";

export const getAvailabilityStatusText = (
  userInfo: any,
  itemStatus?: number
) => {
  switch (itemStatus) {
    case GlobalEnum.OUT_ON_MEMO:
      return userInfo?.onHandText(GlobalEnum.OUT_ON_MEMO);
    case GlobalEnum.ON_HAND:
      return userInfo?.onHandText(GlobalEnum.ON_HAND);
    case GlobalEnum.PLEASE_EMAIL:
      return userInfo?.onHandText(GlobalEnum.PLEASE_EMAIL);
    default:
      return userInfo?.onHandText(GlobalEnum.OUT_ON_MEMO);
  }
};

export const getAvailabilityStatus = (item?: any) => {
  switch (item?.available) {
    case GlobalEnum.OUT_ON_MEMO:
      return "error-01";
    case GlobalEnum.ON_HAND:
      return "success-01";
    case GlobalEnum.PLEASE_EMAIL:
    default:
      return "warn-01";
  }
};
export const getTwoProductProperty = (
  productsType?: string,
  postFixFirst?: string,
  secondProductType?: string,
  postFixSecond?: string
) => {
  let propertyValue = "-";
  if (productsType || secondProductType) {
    propertyValue =
      (productsType ? productsType + postFixFirst + ", " : "") +
      (secondProductType ? secondProductType + postFixSecond : "");
  }
  return propertyValue;
};

export const getProductProperty = (productsType?: string, postFix?: string) => {
  let propertyValue = "-";
  if (productsType) {
    propertyValue = productsType + postFix;
    propertyValue = propertyValue.replace(/\n/g, "<br/>");
  }
  return propertyValue;
};

export const containsHTML = (text: string): boolean => {
  const htmlRegex = /<\/?[a-z][\s\S]*>/i;
  return htmlRegex.test(text);
};

export const getLocationProperty = (
  localSelectedLocation: any,
  otherSelectedLocation: any,
  key: string,
  preFix: string,
  isPrimary?: boolean
) => {
  let propertyValue = "-";

  if (isPrimary) {
    if (localSelectedLocation && localSelectedLocation[preFix]) {
      propertyValue =
        "+" + localSelectedLocation[preFix] + " " + localSelectedLocation[key];
    } else if (localSelectedLocation) {
      propertyValue =
        localSelectedLocation[key] === "" ? "-" : localSelectedLocation[key];
    }
  } else {
    if (otherSelectedLocation && otherSelectedLocation[preFix]) {
      propertyValue =
        "+" + otherSelectedLocation[preFix] + " " + otherSelectedLocation[key];
    } else if (otherSelectedLocation) {
      propertyValue =
        otherSelectedLocation[key] === "" ? "-" : otherSelectedLocation[key];
    }
  }

  return propertyValue;
};

export const checkValidationValue = (
  validateProductType: any,
  key: string,
  showNumber: any
) => {
  let primaryLocation = validateProductType?.find(
    (item: any) => item.is_primary
  );
  if (key === "socialmedia") {
    return showNumber;
  }
  if (primaryLocation) {
    if (primaryLocation[key]) {
      return showNumber;
    }
  }
  return false;
};

export const getLocalProperty = (propertyProductType: any, key: string) => {
  return !!propertyProductType?.[key];
};

export const filterDetailsArray = (array: any, priceMode: any, t: any) => {
  const commonExcludedTitles = [
    "Disc",
    "Location",
    "Supplier",
    "City",
    "Country",
    "Contact",
    "Office",
    "Mobile",
    "Supplier's Comments",
  ];

  const priceModeSpecificExclusions = {
    0: [
      "Total Price",
      "P/ct",
      "Total Price",
      t("findMatch.showPhoneNumber.text"),
    ],
    2: ["Last Refreshed", t("findMatch.showPhoneNumber.text")],
  };

  const exclusions = [
    ...commonExcludedTitles,
    ...(priceModeSpecificExclusions[priceMode] || []),
  ];

  return array.filter(
    (item) =>
      !exclusions.includes(item.title) &&
      item.description !== t("findMatch.showPhoneNumber.text")
  );
};

export const dataMapValidateValue = (
  dataProperty: string,
  dataType: string,
  isPrimary: boolean,
  isCustomApp: boolean,
  itemDetail: any,
  otherDetail: any,
  currentIndex: any,
  localSelectedLocation: any,
  otherSelectedLocation: any,
  isJewelry: boolean,
  dateFormat: any,
  userCurrency: any,
  userInfo: any,
  hideCertOnMatchPair: boolean = false,
  priceMode: PriceModes,
  supplierSpecificCommentInOrangeMode: boolean = false,
  t: any
) => {
  let dataMapedValue = "-";
  switch (dataProperty) {
    case "stock_num":
      dataMapedValue = getProductProperty(
        isPrimary
          ? (!isCustomApp &&
            itemDetail?.bmh_request_type !== "retail_buy_request"
              ? "VDB-"
              : "") + itemDetail?.stock_num
          : (!isCustomApp &&
            otherDetail?.[currentIndex]?.bmh_request_type !==
              "retail_buy_request"
              ? "VDB-"
              : "") + otherDetail?.[currentIndex]?.stock_num,
        ""
      );
      break;
    case "lab":
      let labCertLabel = isPrimary
        ? itemDetail?.lab +
          (!hideCertOnMatchPair &&
          itemDetail?.cert_num &&
          itemDetail?.cert_num !== null &&
          itemDetail?.cert_num !== ""
            ? " #" + itemDetail?.cert_num
            : "")
        : otherDetail?.[currentIndex]?.lab +
          (!hideCertOnMatchPair &&
          otherDetail?.[currentIndex]?.cert_num &&
          otherDetail?.[currentIndex]?.cert_num !== null &&
          otherDetail?.[currentIndex]?.cert_num !== ""
            ? " #" + otherDetail?.[currentIndex]?.cert_num
            : "");

      dataMapedValue = getProductProperty(labCertLabel, "");
      break;
    case "city":
      if (dataType === "locations") {
        dataMapedValue = getLocationProperty(
          localSelectedLocation,
          otherSelectedLocation,
          dataProperty,
          "",
          isPrimary
        );
      } else {
        dataMapedValue = getTwoProductProperty(
          isPrimary
            ? isJewelry
              ? itemDetail?.vendor_city
              : itemDetail?.city
            : isJewelry
            ? otherDetail?.[currentIndex]?.vendor_city
            : otherDetail?.[currentIndex]?.city,
          "",
          isPrimary
            ? isJewelry
              ? itemDetail?.vendor_country
              : itemDetail?.country
            : isJewelry
            ? otherDetail?.[currentIndex]?.vendor_country
            : otherDetail?.[currentIndex]?.country,
          ""
        );
      }
      break;
    case "country":
      if (dataType === "locations") {
        dataMapedValue = getLocationProperty(
          localSelectedLocation,
          otherSelectedLocation,
          dataProperty,
          "",
          isPrimary
        );
      }
      break;
    case "contact_person":
      dataMapedValue = getLocationProperty(
        localSelectedLocation,
        otherSelectedLocation,
        dataProperty,
        "",
        isPrimary
      );

      break;
    case "vendor_name":
      if (dataType === "key_value") {
        dataMapedValue = getProductProperty(
          isPrimary
            ? itemDetail?.[dataProperty as keyof typeof itemDetail]
            : otherDetail?.[currentIndex]?.[
                dataProperty as keyof typeof itemDetail
              ],
          ""
        );
      } else {
        dataMapedValue = getLocationProperty(
          localSelectedLocation,
          otherSelectedLocation,
          "location_name",
          "",
          isPrimary
        );
      }

      break;
    case "office_phone":
      if (dataType === "hideview") {
        dataMapedValue = getLocationProperty(
          localSelectedLocation,
          otherSelectedLocation,
          dataProperty,
          "contact_phone_country_code",
          isPrimary
        );
      }
      break;
    case "mobile_phone":
      if (dataType === "hideview") {
        dataMapedValue = getLocationProperty(
          localSelectedLocation,
          otherSelectedLocation,
          dataProperty,
          "mobile_phone_country_code",
          isPrimary
        );
      }
      break;
    case "socialmedia":
      getLocationProperty(
        localSelectedLocation,
        otherSelectedLocation,
        "mobile_phone",
        "mobile_phone_country_code",
        true
      );
      break;
    case "last_updated_at":
      let validDate = isPrimary
        ? itemDetail?.last_updated_at !== null
          ? itemDetail?.last_updated_at
          : "-"
        : otherDetail?.[currentIndex]?.last_updated_at !== null
        ? otherDetail?.[currentIndex]?.last_updated_at
        : "-";
      dataMapedValue =
        validDate !== "-"
          ? getProductProperty(
              moment(
                isPrimary
                  ? itemDetail?.last_updated_at
                  : otherDetail?.[currentIndex]?.last_updated_at
              ).format(dateFormat),
              ""
            )
          : validDate;
      break;
    case "depth_percent":
      dataMapedValue = getProductProperty(
        isPrimary
          ? itemDetail?.depth_percent
          : otherDetail?.[currentIndex]?.depth_percent,
        "%"
      );
      break;
    case "price_per_carat":
      let itemPriceValue = isPrimary
        ? itemDetail?.price_per_carat
        : otherDetail?.[currentIndex]?.price_per_carat;

      if (
        itemPriceValue === null ||
        itemPriceValue === "0" ||
        itemPriceValue === "0.0"
      ) {
        dataMapedValue = "-";
        break;
      }

      dataMapedValue = getProductProperty(
        currency(
          isPrimary
            ? itemDetail?.price_per_carat
            : otherDetail?.[currentIndex]?.price_per_carat,
          {
            symbol: userCurrency,
            precision: 0,
          }
        ).format(),
        ""
      );
      break;
    case CustomisationKey.discount_percent:
      dataMapedValue = getProductProperty(
        currency(
          isPrimary
            ? itemDetail?.discount_percent
            : otherDetail?.[currentIndex]?.discount_percent,
          {
            symbol: "",
            precision: 2,
          }
        ).format(),
        "%"
      );
      break;
    case "available":
      dataMapedValue = getProductProperty(
        getAvailabilityStatusText(
          userInfo,
          isPrimary
            ? itemDetail?.available
            : otherDetail?.[currentIndex]?.available
        ),
        ""
      );
      break;
    case "total_sales_price":
      let itemTotalPriceValue = isPrimary
        ? itemDetail?.total_sales_price
        : otherDetail?.[currentIndex]?.total_sales_price;

      if (
        itemTotalPriceValue === null ||
        itemTotalPriceValue === "0" ||
        itemTotalPriceValue === "0.0"
      ) {
        dataMapedValue = "-";
        break;
      }

      dataMapedValue = getProductProperty(
        currency(
          isPrimary
            ? itemDetail?.total_sales_price
            : otherDetail?.[currentIndex]?.total_sales_price,
          {
            symbol: userCurrency,
            precision:
              (userInfo?.user?.feature_settings?.round_up_prices &&
                !isMeleeItem(
                  isPrimary ? itemDetail : otherDetail?.[currentIndex]
                )) ||
              hasZeroDecimals(itemTotalPriceValue)
                ? 0
                : 2,
          }
        ).format(),
        ""
      );
      break;
    case "table_percent":
      dataMapedValue = getProductProperty(
        currency(
          isPrimary
            ? itemDetail?.table_percent
            : otherDetail?.[currentIndex]?.table_percent,
          {
            symbol: "",
            precision: 0,
          }
        ).format(),
        "%"
      );
      break;
    case "crown_height":
      dataMapedValue = getTwoProductProperty(
        isPrimary
          ? itemDetail?.crown_height
          : otherDetail?.[currentIndex]?.crown_height,
        "%",
        isPrimary
          ? itemDetail?.crown_angle
          : otherDetail?.[currentIndex]?.crown_angle,
        "°"
      );
      break;
    case "pavilion_depth":
      dataMapedValue = getTwoProductProperty(
        isPrimary
          ? itemDetail?.pavilion_depth
          : otherDetail?.[currentIndex]?.pavilion_depth,
        "%",
        isPrimary
          ? itemDetail?.pavilion_angle
          : otherDetail?.[currentIndex]?.pavilion_angle,
        "°"
      );
      break;
    case "color":
      dataMapedValue = colorStringForShort(
        false,
        isPrimary ? itemDetail : otherDetail?.[currentIndex]
      );
      break;
    case "comment":
      dataMapedValue = getCommentData(
        isPrimary
          ? getProductProperty(
              itemDetail?.[dataProperty as keyof typeof itemDetail],
              ""
            )
          : getProductProperty(
              otherDetail?.[currentIndex]?.[
                dataProperty as keyof typeof itemDetail
              ],
              ""
            ),
        isPrimary ? itemDetail : otherDetail?.[currentIndex],
        priceMode,
        supplierSpecificCommentInOrangeMode,
        t
      );
      break;
    case "supplier_specific_comment":
      let supplierComment = getProductProperty(
        itemDetail?.supplier_specific_comment,
        ""
      );
      if (priceMode === PriceModes.WHITE) {
        const deliveryStr = itemDetail?.estimated_delivery
          ? ` | ${t(
              "productDetailPage.estimatedDelivery.text",
              "Estimated Delivery:"
            )} ${itemDetail.estimated_delivery}`
          : "";
        supplierComment += deliveryStr;
      }
      dataMapedValue = supplierComment;
      break;
    default:
      dataMapedValue = getProductProperty(
        isPrimary
          ? itemDetail?.[dataProperty as keyof typeof itemDetail]
          : otherDetail?.[currentIndex]?.[
              dataProperty as keyof typeof itemDetail
            ],
        ""
      );
  }
  return dataMapedValue;
};
